var render = function render(){var _vm=this,_c=_vm._self._c;return _c('info-screen',{attrs:{"title":_vm.title,"text":_vm.text,"action":_vm.nextScreen,"button-text":_vm.$ml.get('sendCodeEnterCode'),"headerImg":_vm.callEnabled ? 12 : 11}},[_c('a',{staticClass:"link",on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.changeText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }